import './NoBooking.css';
import React, { useState } from 'react';

const NoBooking = () => {
    
    return (
        <>

            <div className="profileBooking p-3">
                <h5 className="text-white text-start container">Complete Your Booking</h5>
            </div>
            <div className="profileMainContainer py-5">
                <div className="container row m-auto personalInfoDiv">
                    <div className="personalInfoLeft">
                        <div className='personalUserimg'>
                            <h5 className='text-start'>Your Bookings</h5>
                        </div>
                        <div className="profileOptions">
                            <div className="profileEdit my-2">
                                <img src="./assets/images/upcomingIcon.png" alt="Edit Profile" />
                                <a href="">Upcoming</a>
                            </div>
                            <div className="profileEdit my-2">
                                <img src="/assets/images/cancelIcon.png" alt="change password" />
                                <a href="">Cancelled</a>
                            </div>
                            <div className="profileEdit my-2">
                                <img src="/assets/images/completeIcon.png" alt="change password" />
                                <a href="">Completed</a>
                            </div>
                        </div>
                    </div>

                    <div className='ProfileRightContainer'>

                        <div className="personalInfoRight">
                            <div className="bookingSearchBar">
                                <input type="text" placeholder='Search For Booking' /> 
                                <img src="/assets/images/searchIcon.png" alt="" />
                            </div>
                        </div>

                        <div className="personalInfoRight mt-4">
                            <div className="personalInfoContainer">
                                <div className="infoCard">
                                    <div className="cardHeader">
                                        <h4>Upcoming Bookings</h4>
                                    </div>
                                    <div className="noBookingContainer mt-4">
                                        <img src="/assets/images/Noupcoming.png" alt="" />
                                        <p>No upcoming bookings. Plan your next journey now!</p>
                                        <button>Book a Flight</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="personalInfoRight mt-4">
                            <div className="personalInfoContainer">
                                <div className="infoCard">
                                    <div className="cardHeader">
                                        <h4>Cancelled Bookings</h4>
                                    </div>
                                    <div className="noBookingContainer mt-4">
                                        <img src="/assets/images/nocancel.png" alt="" />
                                        <p>No canceled bookings. Manage your travel plans smoothly.!</p>
                                        <button>Book a Flight</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="personalInfoRight mt-4">
                            <div className="personalInfoContainer">
                                <div className="infoCard">
                                    <div className="cardHeader">
                                        <h4>Completed Bookings</h4>
                                    </div>
                                    <div className="noBookingContainer mt-4">
                                        <img src="/assets/images/nocompleted.png" alt="" />
                                        <p>No completed bookings yet. Start exploring the world!</p>
                                        <button>Book a Flight</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default NoBooking;
